import { syncSceneryToTheme } from "./zen_theme_scenery";
import { persistAppearance, serverColorTheme } from "./appearance_prefs";

export const THEME_KEY = "emailpa-theme";

const faviconSuffix = (theme) => (theme === "dark" ? "-night" : "-day");

export const faviconPaths = (theme) => {
    const suffix = faviconSuffix(theme);
    return {
        svg: `/favicon${suffix}.svg`,
        ico: `/favicon${suffix}.ico`,
        png16: `/favicon${suffix}-16x16.png`,
        png32: `/favicon${suffix}-32x32.png`,
        apple: `/apple-touch-icon${suffix}.png`
    };
};

export const syncFavicon = (theme) => {
    const paths = faviconPaths(theme);
    document.querySelectorAll("[data-theme-favicon]").forEach((link) => {
        const kind = link.getAttribute("data-theme-favicon");
        if (paths[kind]) link.href = paths[kind];
    });
    document.querySelectorAll("[data-theme-logo]").forEach((img) => {
        img.src = paths.svg;
    });
};

// localStorage, then the member's stored server preference, then the OS hint.
// See appearance_prefs.js for why localStorage takes precedence.
export const getSavedTheme = () => {
    // A page that guests in the extension's panel (layouts/panel) follows the
    // browser, never the member's choice in the app.
    if (document.documentElement.hasAttribute("data-theme-follows-system")) {
        return window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
    }
    let saved = localStorage.getItem(THEME_KEY);
    if (saved === "dark" || saved === "light") return saved;
    let stored = serverColorTheme();
    if (stored === "dark" || stored === "light") return stored;
    let prefersDark = window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;
    return prefersDark ? "dark" : "light";
};

export const applyTheme = (theme) => {
    const t = theme === "dark" ? "dark" : "light";
    document.documentElement.setAttribute("data-bs-theme", t);
    syncFavicon(t);
};

export const setTheme = (theme) => {
    const next = theme === "dark" ? "dark" : "light";
    applyTheme(next);
    localStorage.setItem(THEME_KEY, next);
    persistAppearance({ color_theme: next });
    syncSceneryToTheme(next);
    document.dispatchEvent(new CustomEvent("emailpa:themechange", { detail: { theme: next } }));
};

export const syncThemeBadge = (checked) => {
    const badge = document.getElementById("badge-dark-mode");
    if (!badge) return;
    const on = !!checked;
    badge.textContent = on ? "On" : "Off";
    badge.classList.remove("bg-success", "bg-secondary");
    badge.classList.add(on ? "bg-success" : "bg-secondary");
};

export const syncThemeToggles = () => {
    const saved = getSavedTheme();
    applyTheme(saved);
    const isDark = saved === "dark";
    document.querySelectorAll("[data-theme-target='toggle']").forEach((toggle) => {
        toggle.checked = isDark;
    });
    syncThemeBadge(isDark);
};
